import { render } from "./CrmSegmentsBlocks.vue?vue&type=template&id=0f3297d5&scoped=true"
import script from "./CrmSegmentsBlocks.vue?vue&type=script&lang=js"
export * from "./CrmSegmentsBlocks.vue?vue&type=script&lang=js"

import "./CrmSegmentsBlocks.vue?vue&type=style&index=0&id=0f3297d5&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3297d5"]])

export default __exports__